export const supplierConsult = {
  form: {
    supplier_name: "Supplier Name",
    email: "Supplier Email",
    telephone: "Phone",
    address: "Address",
    documents: "Internal Documents",
    collaborators: "Collaborators",
    add_collaborator: "Add Collaborator",
    delete_success: "User deleted successfully!",
    delete_error: "Error while deleting user!",
  },
};
